module.exports = __webpack_public_path__ + "img/bg1.a7acc6b2.jpg";